export default [
	{
		path: '/analytics/graphs',
		name: 'analytics.graphs',
		component: () => import('@/views/Analytics/Graphs.vue'),
		meta: { requiresAuth: true, permission: 'view_analytics' }
	},
	{
		path: '/analytics/maps',
		name: 'analytics.maps',
		component: () => import('@/views/Analytics/Maps.vue'),
		meta: { requiresAuth: true, permission: 'view_analytics' }
	}
]
